import { FC } from 'react';
import { CloseButtonStyled } from './style';
import { Props } from './types';
import { FAIcon } from '@packages/ui-components';

const CloseButton: FC<Props & { children?: any }> = ({ onClick, isFullscreen }) => (
  <CloseButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
    <FAIcon icon="faTimes" size={16} />
  </CloseButtonStyled>
);

export default CloseButton;
